import { Helmet } from 'react-helmet';
import type { Product } from '../../bff-api/products/model';

export const ImageSchema = ({ product }: { product?: Product }): JSX.Element | null => {
    if (product) {
        const { c_imageSchema } = product;

        if (c_imageSchema) {
            return (
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(c_imageSchema, null, 2)}
                    </script>
                </Helmet>
            );
        }
    }

    return null;
};
